export default __webpack_public_path__ + "static/media/eye-open.d331b323.svg";